import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AiOutlineCaretRight } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { imageUrl } from '../../config/apiUrl';
import { useSocket } from '../../context/SocketContext';
import { getWindowWidth } from '../../CustomHooks/isMobileViewHook';
import { signOutRequest } from '../../store/auth/authSlice';
import { unsetAllNotification } from '../../store/notification/notificationSlice';
import { getUniqueBrowserId } from '../../utils/helpers';
import classes from './AccountInfoLayout.module.css';

export const MenuList = ({ isMobile, d, safeNavigate }) => {
  const socket = useSocket();
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const { user } = useSelector((state) => state?.authReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function logout() {
    socket?.current?.emit('logout', { userId: user?._id, deviceId: getUniqueBrowserId() });
    localStorage.removeItem('uniqueBrowserId');
    socket.current.close();

    //! TODO: clear all necessary data [Very Important]
    dispatch(signOutRequest());
    dispatch(unsetAllNotification());

    navigate('/', { replace: true });
  }

  const options =
    user?.role == 'user'
      ? [
          {
            name: d('accountSettings'),
            path: '/account-settings'
          },
          {
            name: d('followedAgents'),
            path: '/followed-agents'
          },

          {
            name: d('savedProperties'),
            path: '/saved-properties'
          },
          {
            name: d('savedEvents'),
            path: '/saved-events'
          },
          {
            name: d('savedProjects'),
            path: '/saved-projects'
          },
          {
            name: d('savedSearches'),
            path: '/saved-searches'
          },
          {
            name: d('compareList'),
            path: '/compare-list'
          },

          {
            name: d('contactedProperties'),
            path: '/contacted-properties'
          },
          {
            name: d('propertiesRequests'),
            path: '/property-requests'
          }
        ]
      : [
          {
            name: 'Dashboard',
            path: `/${user?.role}/dashboard`
          }
        ];

  return (
    <>
      {!isMobile && (
        <>
          <div>
            <div className={classes.profile_head}>
              <div className={classes.profile_img}>
                <img
                  src={imageUrl(user?.photo)}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'https://www.w3schools.com/howto/img_avatar.png';
                  }}
                  alt="profile"
                />
              </div>
              <div className={classes.profile_name}>
                <p>
                  <span>
                    <h5
                      title={
                        (user?.role == 'company' && user?.companyName?.[selectedLanguage]) ||
                        (user?.role == 'agent' && user?.agentName?.[selectedLanguage]) ||
                        (user?.role == 'user' && user?.firstName + ' ' + user?.lastName)
                      }>
                      {(user?.role == 'company' && user?.companyName?.[selectedLanguage]) ||
                        (user?.role == 'agent' && user?.agentName?.[selectedLanguage]) ||
                        (user?.role == 'user' && user?.firstName + ' ' + user?.lastName)}
                    </h5>
                  </span>
                  <h6 onClick={logout} className="c-p">
                    {d('logout')}
                  </h6>
                </p>
              </div>
            </div>
            {options?.map((item, index) => {
              return (
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    if (safeNavigate) {
                      safeNavigate(item?.path);
                      return;
                    }
                    navigate(item?.path);
                  }}
                  style={{
                    cursor: 'pointer',
                    background: window.location.pathname == item?.path && '#f6f6f6'
                  }}
                  key={index}
                  className={classes.item_lists}>
                  <p>{item?.name}</p>

                  <div className={classes.chevron_icon}>
                    <AiOutlineCaretRight color="var(--secondary-clr)" />
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
      {/* <Button onClick={handleClick}>
            <GiHamburgerMenu />
          </Button>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}>
            <div>
              <div className={classes.profile_head}>
                <div className={classes.profile_img}>
                  <img
                    src={imageUrl(user?.photo)}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://www.w3schools.com/howto/img_avatar.png';
                    }}
                    alt="profile"
                  />
                </div>
                <div className={classes.profile_name}>
                  <p>
                    <span>
                      <h5>
                        {(user?.role == 'company' && user?.companyName?.[selectedLanguage]) ||
                          (user?.role == 'agent' && user?.agentName?.[selectedLanguage]) ||
                          (user?.role == 'user' && user?.firstName + ' ' + user?.lastName)}
                      </h5>
                    </span>

                    <h6 onClick={logout}>{d('logout')}</h6>
                  </p>
                </div>
              </div>
              {options?.map((item, index) => {
                return (
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      if (safeNavigate) {
                        safeNavigate(item?.path);
                        return;
                      }
                      navigate(item?.path);
                    }}
                    style={{
                      cursor: 'pointer',
                      background: window.location.pathname == item?.path && '#f6f6f6'
                    }}
                    key={index}
                    className={classes.item_lists}>
                    <p>{item?.name}</p>
                    <div className={classes.chevron_icon}>
                      <AiOutlineCaretRight color="var(--secondary-clr)" />
                    </div>
                  </div>
                );
              })}
            </div>
          </Popover>
        </>
      ) : ( */}
    </>
  );
};

const AccountInfoLayout = ({ children }) => {
  const { t } = useTranslation('webCommon');

  const d = (a) => t(`userSidebarOptions.${[a]}`);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    getWindowWidth(setScreenWidth);
  }, []);
  return (
    <Container>
      <div className={classes.main_conti} data-direction-col={screenWidth < 1400}>
        <div className={classes.sidebar_main}>
          <MenuList isMobile={screenWidth < 1400} d={d} />
        </div>
        <div
          style={{
            width: '100%'
          }}>
          {children}
        </div>
      </div>
    </Container>
  );
};

export default AccountInfoLayout;
